// Единствено/множествено число за броячите в справките.
//
// Проектът НЕ ползва автоматичните множествени форми на i18next, а двойка
// ключове — така преводачът вижда и двата текста. Този помощник избира между
// тях, за да не се разпилява един и същ тернарен израз по компонентите.

import type { TFunction } from "i18next";

export const pluralLabel = (
  t: TFunction,
  count: number,
  oneKey: string,
  manyKey: string,
  extra?: Record<string, unknown>,
): string =>
  count === 1
    ? t(oneKey, { count, ...extra })
    : t(manyKey, { count, ...extra });
